<template>
    <f7-page
        name="Data"
        class="onboardingBg"
    >
        <f7-navbar
            large
            large-transparent
            title-large="My Data"
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>My Data</f7-nav-title>
        </f7-navbar>

        <f7-block-title>What you can do</f7-block-title>
        <f7-block>
            We know that your privacy is very important and are committed to transparency in how and what data we collect, which is why we are fully compliant to the EU General Data Protection Regulation, which states that users of Coral can export their data and have the right to remove their data completely at any time. This right is granted to anyone regardless of location or nationality.
        </f7-block>
        <f7-block-title>Actions</f7-block-title>
        <f7-list
            inset
            form
            class="bordered"
        >
            <f7-list-item
                link="#"
                @click="exportData"
            >Export my personal data</f7-list-item>
            <f7-list-item
                link="#"
                @click="deleteUser"
            >Delete my account & data</f7-list-item>
            <f7-list-item link="/help">Help</f7-list-item>
        </f7-list>

    </f7-page>
</template>

<script>
export default {
    store: ['api', 'user'],
    data () {
        return {};
    },
    computed: {
        device: function () {
            return f7.device;
        }
    },
    created: function () { },
    mounted: function () { },
    methods: {
        exportData: function () {
            f7.dialog.confirm(
                'Request a download of all the data we collect from you? This includes traits, personal data, comments, flags, question responses etc..',
                () => {
                    f7.dialog.prompt(
                        'Enter an email where we can send your data?',
                        (email) => {
                            // return f7.dialog.alert('Disabled during beta.');
                            this.$http.post(`${this.api}/users/${this.user.id}/dataRequest`, {
                                email,
                            }).then(
                                () => {
                                    f7.dialog.alert(
                                        'We thank you for your request. You should recieve your data within an hour.'
                                    );
                                },
                                response => {
                                    f7.dialog.alert(response.body ? response.body.message : 'Unknown error');
                                }
                            );
                        },
                        () => {

                        },
                        this.user.email || ''
                    );
                });
        },
        deleteUser: function () {
            let doDelete = () => {
                f7.dialog.confirm('Are you sure you want to delete your user, and all its data forever?', () => {
                    f7.dialog.prompt('Any reason you would like to mention to us?', message => {
                        this.$http
                            .delete(`${this.api}/users/${this.user.id}`, {
                                body: {
                                    message
                                }
                            })
                            .then(
                                () => {
                                    const onDone = () => {
                                        setTimeout(() => {
                                            localStore.clear();
                                            this.$events.fire('userDelete');
                                            if (pgap) {
                                                window.location.reload();
                                            } else {
                                                window.location.href = '/';
                                            }
                                        }, 400);
                                    };
                                    f7.dialog.confirm(
                                        'Your account will be deleted soon! Please allow for 48h!',
                                        onDone,
                                        onDone
                                    );
                                },
                                response => {
                                    f7.dialog.alert(response.body ? response.body.message : 'Unknown error');
                                }
                            );
                    });
                });
            }
            if (this.user.isSubscribed) {
                f7.dialog.confirm('Deleting your account does not cancel your subscription as this is handled via the app stores or payment providers. You should probably cancel your subscription first! Are you sure you wish to continue?', () => {
                    doDelete();
                });
            } else {
                doDelete();
            }
        }
    }
};
</script>

<style lang="less" scoped>
.center {
    text-align: center;
}
</style>
